import type { UserOverview } from '@/types/messages.ts';
import { UsageCostModal } from '@/components/UsageCostModal.tsx';
import { MemoryViewerDialog } from '@/components/users/MemoryViewerDialog.tsx';
import { ConversationDebugDialog } from './ConversationDebugDialog.tsx';

/** The one dialog the messages page may have open. */
export type MessagesDialog =
  | { kind: 'debug' }
  | { kind: 'cost' }
  | { kind: 'memories'; userId: string; handles: string[] };

export interface MessagesDialogsProps {
  dialog: MessagesDialog | null;
  onChange: (dialog: MessagesDialog | null) => void;
  /** The conversation being read on its own; a channel read as one has nothing to inspect. */
  readingConversation: string | undefined;
  person: UserOverview | null;
}

/** What the transcript opens on top of itself: the debug view, the cost and the memories. */
export function MessagesDialogs({
  dialog,
  onChange,
  readingConversation,
  person,
}: MessagesDialogsProps) {
  return (
    <>
      {readingConversation && (
        <ConversationDebugDialog
          conversationId={readingConversation}
          open={dialog?.kind === 'debug'}
          onOpenChange={(open) => onChange(open ? { kind: 'debug' } : null)}
        />
      )}

      {person && (
        <UsageCostModal
          userId={person.id}
          userName={`${person.first_name ?? ''} ${person.last_name ?? ''}`.trim()}
          organisationId={person.organisation.id}
          organisationName={person.organisation.name ?? undefined}
          open={dialog?.kind === 'cost'}
          onClose={() => onChange(null)}
        />
      )}

      {dialog?.kind === 'memories' && (
        <MemoryViewerDialog
          userId={dialog.userId}
          offeredHandles={dialog.handles}
          open
          onOpenChange={(open) => {
            if (!open) onChange(null);
          }}
        />
      )}
    </>
  );
}
